import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'

import config from '../../../config'

export default function ContributorListItem({
  contributor,
  onSelect,
  onDelete,
  language = 'th',
}) {
  return (
    <MediaWithPointer
      onClick={e => {
        console.log('click item')
        if (onSelect) onSelect(contributor)
      }}
    >
      <figure className="media-left">
        <p className="image is-64x64">
          <img
            src={`${config.imageURLPrefix}/${contributor.mainImageId}`}
            alt={_.get(contributor, `name.${language}`)}
          />
        </p>
      </figure>
      <div className="media-content">
        <div className="content">
          <p>
            <strong>{_.get(contributor, `name.${language}`)}</strong> <br />
            <small>{_.get(contributor, `position.${language}`)}</small>
            <br />
            <small>{_.get(contributor, `contact.${language}`)}</small>
          </p>
        </div>
      </div>
      <div className="media-right">
        <button
          className="delete"
          onClick={e => {
            e.stopPropagation()
            onDelete(contributor)
          }}
        />
      </div>
    </MediaWithPointer>
  )
}

const MediaWithPointer = styled.article.attrs({
  className: 'media',
})`
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/templates/contributor-list/ContributorListItem.js